import React, { lazy, Suspense } from 'react';
import PropTypes from "prop-types";
import { getExtraField } from 'gatsby-core-theme/src/helpers/getters';
import { generatePlaceholderString } from 'gatsby-core-theme/src/helpers/generators.mjs';
import Security from '~images/icons/security';

export const footerContent = (props) => {
  let ModuleComponent = null;

  switch (props.footerTemplate) {
    case 'template_one':
      ModuleComponent = lazy(() => import('./variants/template-one'));
      return <ModuleComponent {...props} />;
    case 'template_two':
      ModuleComponent = lazy(() => import('./variants/template-two'));
      return <ModuleComponent {...props} />;
    case 'template_three':
      ModuleComponent = lazy(() => import('./variants/template-three'));
      return <ModuleComponent {...props} />;
    default:
      ModuleComponent = lazy(() => import('./variants/template-one'));
      return <ModuleComponent {...props} />;
  }
};

const Footer = (props) => {
  const { template ,page, section } = props;

  const helpText = `
  <p>
    Gambling can be addictive, please play responsibly.
    <br />
    If you are a problem gambler, please visit this
    <a
      href="https://www.begambleaware.org/"
      target="_blank"
      rel="nofollow"
      class="footer-gtm"
    >
      website
    </a>
    in order to get help.
  </p>`;

  const footerLogos = getExtraField(section?.extra_fields, 'logos');

  const getFooterLogos = () => {
    let refactoredFooterLogos = { children: [] };

    if (footerLogos === null || !footerLogos.children) {
      refactoredFooterLogos = {
        children: [...page?.page?.responsibleGaming],
      };
    } else {
      refactoredFooterLogos = {
        ...footerLogos,
        children: [...page?.page?.responsibleGaming, ...footerLogos.children],
      };
    }

    return refactoredFooterLogos;
  };

  const helpline = () => {
    if (getExtraField(section?.extra_fields, 'helpline')) {
      return generatePlaceholderString(getExtraField(section?.extra_fields, 'helpline'));
    }
    return null;
  };

  props = {
    ...props,
    showLinks: template !== 'ppc',
    copyrightDisclaimer: getExtraField(section?.extra_fields, 'copyright_disclaimer'),
    footerLogos: page?.page?.responsibleGaming?.length ? getFooterLogos() : footerLogos,
    hasDisclaimer: true,
    showCopyright: true,
    footerMenu: getExtraField(section?.extra_fields, 'links'),
    asSeenOn: getExtraField(section?.extra_fields, 'as_seen_on'),
    gamblingText: getExtraField(section?.extra_fields, 'gambling_text'),
    socialIcons: getExtraField(section?.extra_fields, 'social_icons'),
    logo: '/images/logo.svg',
    dmcaImage: '/images/dmca.png',
    dmcaWidth: 100,
    dmcaHeight: 30,
    securityIcon: <Security />,
    helpText,
    phoneNum: helpline(),
    copyrightCustomText: getExtraField(section?.extra_fields, 'copyright_text'),
  };

  return <Suspense fallback={<></>}>{footerContent(props)}</Suspense>;
};

export default Footer;

Footer.propTypes = {
  template: PropTypes.string,
  section: PropTypes.shape({
    extra_fields: PropTypes.shape({}),
  }),
  page: PropTypes.shape({
    page: PropTypes.shape({
      responsibleGaming: PropTypes.arrayOf(PropTypes.shape({})),
    })
  }),
}